import { Injectable } from '@angular/core';
import { MenuItem } from '@app/components/shared/button-menue/model/menu-item';
import { PageId } from '@app/constants/page-id';
import { Icons } from '@app/services/icon-register/icon-register.constants';
import { Roles } from '@app/services/password/model/roles';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class MenuFacadeService {

  constructor(private router: Router) {
  }

  mnuFenceResultAudience = 'Tävlingsresultat';
  mnuStarter = 'Start';
  mnuStop = 'Målgång';
  mnuResult = 'Resultat';
  mnuAdmin = 'Administration';
  mnuFenseResult = 'Hinderbedömning';
  mnuEquipImport = 'Equip import';
  mnuCreateRace = 'Skapa tävling';
  mnuTrackMap = 'Bankarta';
  mnuAdminHome = 'Last-test';

  mnuMainRefferi = 'Överdomare';
  mnuFenceEngineer = 'Banbyggare';
  mnuHelthCare = 'Sjukvårdare';
  mnuPauseRider = 'Stopptid';

  getStewardMenu = (roles: string[]): MenuItem<string>[] => {
    const menuItems: MenuItem<string>[] = [];

    if (roles.find(role => role === Roles.fence)) {
      menuItems.push({
        value: PageId.fenseResult,
        iconName: Icons.rule,
        displayname: this.mnuFenseResult,
        description: 'För hinderfunktionärer'
      });
    }

    if (roles.find(role => role === Roles.finish)) {
      menuItems.push({
        value: PageId.finish,
        iconName: Icons.alarm_on,
        displayname: this.mnuStop,
        description: 'Målgång ryttare'
      });
    }

    if (roles.find(role => role === Roles.start)) {
      menuItems.push({
        value: PageId.start,
        iconName: Icons.pending_actions,
        displayname: this.mnuStarter,
        description: 'Starta ryttare'
      });
    }

    return menuItems;

  };

  getSupportMenu = (): MenuItem<string>[] => {
    const menuItems: MenuItem<string>[] = [];

      menuItems.push({
        value: PageId.fenseResult,
        iconName: Icons.support_agent,
        displayname: this.mnuMainRefferi,
        description: 'Tillkalla överdomare'
      });

    menuItems.push({
      value: PageId.fenseResult,
      iconName: Icons.engineering,
      displayname: this.mnuFenceEngineer,
      description: 'Tillkalla hinder byggare'
    });

    menuItems.push({
      value: PageId.fenseResult,
      iconName: Icons.health_and_safety,
      displayname: this.mnuHelthCare,
      description: 'Tillkalla sjukvårdare'
    });

    return menuItems;

  };

  getRaceMenu = (): MenuItem<string>[] => {
    const menuItems: MenuItem<string>[] = [];

    menuItems.push({
      value: PageId.fenseResult,
      iconName: Icons.pause,
      displayname: this.mnuPauseRider,
      description: 'Starta stopptid'
    });
    return menuItems;
  };

  getPublicMenu = (): MenuItem<string>[] => {
    const menuItems: MenuItem<string>[] = [];

    menuItems.push({
      value: PageId.fenceResultAudience,
      iconName: Icons.workspace_premium,
      displayname: this.mnuFenceResultAudience
    });

  /*  menuItems.push({
      value: PageId.trackMap,
      iconName: Icons.public,
      displayname: this.mnuTrackMap,
      description: 'Live bankarta'
    });*/
    return menuItems;
  };

  getsAdminMenu = (roles: string[]): MenuItem<string>[] => {
    const menuItems: MenuItem<string>[] = [];

    if (roles.find(role => role === Roles.secretariat)) {
      menuItems.push({
        value: PageId.raceResult,
        iconName: Icons.overview,
        displayname: this.mnuResult,
        description: 'Resltat sida'
      });
    }
    return menuItems;
  }

  getManagerMenu = (roles: string[]): MenuItem<string>[] => {
    const menuItems: MenuItem<string>[] = [];

    if (roles.find(role => role === Roles.manager)) {
      menuItems.push({
        value: PageId.manager,
        iconName: Icons.create,
        displayname: this.mnuAdmin,
        description: 'Arrangörsida'
      });
      menuItems.push({
        value: PageId.adminHome,
        iconName: Icons.verified,
        displayname: this.mnuAdminHome,
        description: 'Senaste test'
      });
    }
    return menuItems;
  }

  navigateTo = (role: Roles): void => {
    switch (role) {
      case Roles.start:
        this.router.navigate([`/${PageId.start}`]);
        break;

      case Roles.finish:
        this.router.navigate([`/${PageId.finish}`]);
        break;

      case Roles.fence:
        this.router.navigate([`/${PageId.fenseResult}`]);
        break;

      case Roles.secretariat:
        this.router.navigate([`/${PageId.raceResult}`]);
        break;
      case Roles.manager:
        this.router.navigate([`/${PageId.manager}`]);
        break;
      default:
        console.warn(`No navigation defined for role: ${role}`);
        break;
    }
  }

}
